module.exports = __webpack_public_path__ + "static/logo-desk-52e29f223b66fe0f6104c39ce0e30f0a.svg";